import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Author } from "@domain/lms/content";
import { useOrganization } from "@domain/organization/hooks";
import { useUserProfile } from "@domain/user/hooks";
import { getBanner } from "@utils/banner";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { HookWrapper } from "@ui/components/hookWrapper";
import { ProfileBanner } from "@ui/components/profile/profileBanner";
import { UserDetailedView } from "@ui/components/profile/userDetailedView";

interface AuthorViewProps extends React.HTMLAttributes<HTMLDivElement> {
	author: Author;
}
export const AuthorView: React.FC<AuthorViewProps> = ({ author, ...htmlProps }) => {
	return (
		<UserInfos {...htmlProps}>
			{author.id ? (
				author.type === "USER" ? (
					<HookWrapper hook={() => useUserProfile(author.id)}>
						{({ result: profile }) => (
							<ProfileBanner
								picture={profile?.banner}
								defaultUrl={!profile?.banner ? getBanner(author.id) : undefined}
							/>
						)}
					</HookWrapper>
				) : (
					<HookWrapper hook={() => useOrganization(author.id)}>
						{({ result: organization }) => (
							<ProfileBanner
								picture={organization?.banner}
								defaultUrl={!organization?.banner ? getBanner(author.id) : undefined}
							/>
						)}
					</HookWrapper>
				)
			) : (
				<ProfileBanner defaultUrl={getBanner(author.primaryName)} />
			)}
			<RelativeUserDetailed user={author} />
			{author.id && (
				<Link to={author.type === "USER" ? Path.Profile(author) : Path.Organization(author)}>
					<PrimaryButton>
						{author.type === "USER"
							? I18n.t("course.author.link")
							: author.type === "INSTITUTE"
								? I18n.t("course.institute.link")
								: I18n.t("course.company.link")}
					</PrimaryButton>
				</Link>
			)}
		</UserInfos>
	);
};

const UserInfos = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	padding: 75px 0;
	border-radius: 13px;
	background-color: white;
	a {
		margin-top: 25px;
	}
`;

const RelativeUserDetailed = styled(UserDetailedView)`
	position: relative;
`;
